import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { getUserType, USER_TYPES } from "../config/roles";

export default function RoleRedirect() {
  const { loading, user } = useAuth();
  if (loading) return null;

  if (!user) return <Navigate to="/login" replace />;

  // Admin lands on /admin; everyone else lands on /dashboard (the
  // correct dashboard variant is chosen inside your dashboard index page).
  const uxType = getUserType(user);
  if (uxType === USER_TYPES.ADMIN) return <Navigate to="/admin" replace />;
  if (uxType === USER_TYPES.CEED) return <Navigate to="/ceed" replace />; // ⬅️ NEW

  return <Navigate to="/dashboard" replace />;
}
